/** The Rainlytics event names emitted for a saved-word request. */
export const savedWordRequestEvents = {
  completed: "saved-word-request-ms",
  failed: "saved-word-request-error-ms",
} as const;

/** How a saved-word request ended. */
export type SavedWordRequestOutcome = keyof typeof savedWordRequestEvents;
